module.exports = __webpack_public_path__ + "static/media/82873EED-6A9A-490F-8971-D00A522A174B.cdf832ce.jpeg";